import React from "react";
import "./InfoBar.css";

import ScoreCounter from "./ScoreCounter";
import Timer from "./Timer";

function InfoBar({ score, targetScore, duration, handleTimeUp, isRunning }) {
    return (
        <div className="info-bar"> 
            <ScoreCounter score={score} targetScore={targetScore} />
            {/* Pass score as the resetKey so the timer restarts on level up */}
            <Timer 
                duration={duration} 
                onTimeUp={handleTimeUp} 
                isRunning={isRunning} 
                resetKey={score} 
            />
        </div>
    );
}

export default InfoBar;